<form class="tag-form fx-col fx-jc-center fx-ai-center"  >
  <mat-form-field appearance="fill">
    <mat-label>
      Tag Name
    </mat-label>
    <input #tagInput
           placeholder="Enter a tag name"
           matInput>
  </mat-form-field>
  <button color="primary"
          mat-raised-button
          (click)="addTag(tagInput.value); tagInput.value=''">
    Add Tag
  </button>
  <div class="tag-list fx-col fx-gap-10"  >
    <mat-chip-set>
      <mat-chip *ngFor="let tag of tags"
                (removed)="removeTag(tag)">
        {{tag}}
        <mat-icon matChipRemove>
          cancel
        </mat-icon>
      </mat-chip>
    </mat-chip-set>
  </div>
</form>
<button color="accent"
        mat-raised-button
        (click)="saveTags()">
  Save Tags
</button>
